import { Alert, Collapse, Box } from '@mui/material';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import { useNetworkStatusContext } from '@/mobile/components/NetworkStatusProvider';

export function OfflineBanner() {
  const { connected } = useNetworkStatusContext();

  return (
    <Collapse in={!connected}>
      <Box sx={{ position: 'sticky', top: 0, zIndex: (t) => t.zIndex.appBar + 2 }}>
        <Alert
          severity="warning"
          icon={<CloudOffOutlinedIcon fontSize="inherit" />}
          sx={{ borderRadius: 0, py: 0.25 }}
        >
          You are offline. Changes will sync when connection returns.
        </Alert>
      </Box>
    </Collapse>
  );
}
